import React, { SVGProps } from 'react'

export const PercentSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#FF8640"
      fillRule="evenodd"
      d="M26.594 3.781a2 2 0 0 0-2.813.291L6.448 25.405a2 2 0 1 0 3.104 2.523L26.885 6.594a2 2 0 0 0-.29-2.813Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF8640"
      d="M8.424 14.132c.527.35 1.07.5 1.576.535a3.203 3.203 0 0 0 1.576-.535s5.35-2.369 5.724-6.386c.372-4.016-2.472-4.806-2.472-4.806C11.39 1.836 10.283 4.375 10 5.298c-.283-.923-1.392-3.463-4.828-2.358 0 0-2.844.79-2.472 4.806.373 4.017 5.724 6.386 5.724 6.386Z"
    />
    <path
      fill="#FF8640"
      fillRule="evenodd"
      d="M23.333 25.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 4a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
      clipRule="evenodd"
    />
  </svg>
)
